var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{staticClass:"tsa-tooltipCustomV2",attrs:{"disabled":_vm.tooltipDisabled,"content":_vm.message,"placement":"top","open-delay":200}},[_c('div',{on:{"mouseenter":_vm.mouseenter}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }